// File: components/HUD.tsx
import React from 'react';
import { COLORS } from './config/colors';
import { Song } from './types/common';

interface HUDProps {
  score: number;
  honmoon: number;
  goldenHonmoonTimer: number;
  song: Song;
  isPracticeMode?: boolean;
}

export const HUD: React.FC<HUDProps> = ({ score, honmoon, goldenHonmoonTimer, song, isPracticeMode = false }) => {
  const isGolden = goldenHonmoonTimer > 0;
  const honmoonColor = honmoon < 30 ? 'red' : (isGolden ? COLORS.projectileLight : COLORS.honmoon);
  
  return (
    <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, pointerEvents: "none" }}>
      
      {/* Top Stats Bar */}
      <div style={{ position: "absolute", top: 20, left: 20, right: 20, display: "flex", justifyContent: "space-between", color: "white", fontFamily: "monospace", fontSize: "20px" }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <div className="font-heading tracking-widest flex items-center gap-3">
                {isPracticeMode && (
                    <span className="bg-cyan-600 text-white text-[10px] px-2 py-0.5 rounded-sm shadow-[0_0_10px_#0891b2]">REHEARSAL</span>
                )}
                <span>SCORE: {score.toLocaleString()}</span>
            </div>
            {isGolden && <div className="text-xs text-yellow-400 animate-pulse">★ HYPE MODE ACTIVE ★</div>}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
           <span className="font-heading text-sm tracking-widest">HONMOON:</span> 
           <div style={{ width: '200px', height: '16px', border: '1px solid #555', backgroundColor: '#111', boxShadow: isGolden ? '0 0 15px #ffe600' : 'none', transition: 'box-shadow 0.2s', borderRadius: '4px', overflow: 'hidden' }}>
             <div style={{ width: `${honmoon}%`, height: '100%', backgroundColor: honmoonColor, transition: 'width 0.2s, background-color 0.2s' }} />
           </div>
        </div>
      </div>

    </div>
  );
};